import { defineComponent as F, reactive as U, unref as h, openBlock as H, createElementBlock as I, normalizeClass as j, createElementVNode as D, createCommentVNode as W } from "vue";
const P = {
  a: ["class", "href", "id", "style", "target"],
  abbr: [],
  acronym: [],
  address: ["class", "id", "style"],
  b: ["class", "id", "style"],
  blockquote: ["class", "id", "style"],
  br: ["class", "id", "style"],
  caption: ["class", "id", "style"],
  cite: ["class", "id", "style"],
  code: ["class", "id", "style"],
  col: [
    "align",
    "bgcolor",
    "char",
    "charoff",
    "class",
    "id",
    "style",
    "valign",
    "width"
  ],
  colgroup: [
    "align",
    "bgcolor",
    "char",
    "charoff",
    "class",
    "id",
    "style",
    "valign",
    "width"
  ],
  center: ["class", "id", "style"],
  dd: ["class", "id", "style"],
  del: [],
  dfn: [],
  div: ["align", "class", "dir", "id", "style"],
  dt: ["class", "id", "style"],
  em: ["class", "id", "style"],
  font: ["class", "color", "face", "id", "size", "style"],
  h1: ["align", "class", "dir", "id", "style"],
  h2: ["align", "class", "dir", "id", "style"],
  h3: ["align", "class", "dir", "id", "style"],
  h4: ["align", "class", "dir", "id", "style"],
  h5: ["align", "class", "dir", "id", "style"],
  h6: ["align", "class", "dir", "id", "style"],
  hr: ["align", "size", "width"],
  i: ["class", "id", "style"],
  img: [
    "align",
    "alt",
    "border",
    "class",
    "height",
    "hspace",
    "id",
    "src",
    "style",
    "title",
    "usemap",
    "vspace",
    "width"
  ],
  label: ["class", "id", "style"],
  legend: ["class", "id", "style"],
  li: ["class", "dir", "id", "style", "type"],
  ol: ["class", "dir", "id", "style", "type", "start", "reversed"],
  p: ["align", "class", "dir", "id", "style"],
  pre: ["class", "id", "style"],
  small: [],
  span: ["class", "id", "style"],
  strike: [],
  strong: ["class", "id", "style"],
  style: [],
  sub: ["class", "id", "style"],
  sup: ["class", "id", "style"],
  table: [
    "align",
    "bgcolor",
    "border",
    "cellpadding",
    "cellspacing",
    "class",
    "dir",
    "frame",
    "id",
    "rules",
    "style",
    "width"
  ],
  tbody: ["class", "id", "style"],
  td: [
    "abbr",
    "align",
    "bgcolor",
    "class",
    "colspan",
    "dir",
    "height",
    "id",
    "lang",
    "rowspan",
    "scope",
    "style",
    "valign",
    "width"
  ],
  tfoot: [
    "align",
    "bgcolor",
    "char",
    "charoff",
    "class",
    "id",
    "style",
    "valign"
  ],
  th: [
    "abbr",
    "align",
    "bgcolor",
    "class",
    "colspan",
    "dir",
    "height",
    "id",
    "lang",
    "rowspan",
    "scope",
    "style",
    "valign",
    "width"
  ],
  thead: [
    "align",
    "bgcolol",
    "char",
    "charoff",
    "class",
    "id",
    "style",
    "valign"
  ],
  tr: [
    "align",
    "bgcolor",
    "char",
    "charoff",
    "class",
    "dir",
    "id",
    "style",
    "valign"
  ],
  u: ["class", "id", "style"],
  ul: ["class", "dir", "id", "style"],
  wbr: []
}, G = [
  "script",
  "iframe",
  "textarea",
  "title",
  "noscript",
  "noembed",
  "svg"
], J = [
  "azimuth",
  "background",
  "background-blend-mode",
  "background-clip",
  "background-color",
  "background-image",
  "background-origin",
  "background-position",
  "background-position-x",
  "background-position-y",
  "background-repeat",
  "background-repeat-x",
  "background-repeat-y",
  "background-size",
  "border",
  "border-bottom",
  "border-bottom-color",
  "border-bottom-left-radius",
  "border-bottom-right-radius",
  "border-bottom-style",
  "border-bottom-width",
  "border-collapse",
  "border-color",
  "border-left",
  "border-left-color",
  "border-left-style",
  "border-left-width",
  "border-radius",
  "border-right",
  "border-right-color",
  "border-right-style",
  "border-right-width",
  "border-spacing",
  "border-style",
  "border-top",
  "border-top-color",
  "border-top-left-radius",
  "border-top-right-radius",
  "border-top-style",
  "border-top-width",
  "border-width",
  "box-sizing",
  "break-after",
  "break-before",
  "break-inside",
  "caption-side",
  "clear",
  "color",
  "column-count",
  "column-fill",
  "column-gap",
  "column-rule",
  "column-rule-color",
  "column-rule-style",
  "column-rule-width",
  "column-span",
  "column-width",
  "columns",
  "direction",
  "display",
  "elevation",
  "empty-cells",
  "float",
  "font",
  "font-family",
  "font-feature-settings",
  "font-kerning",
  "font-size",
  "font-size-adjust",
  "font-stretch",
  "font-style",
  "font-synthesis",
  "font-variant",
  "font-variant-alternates",
  "font-variant-caps",
  "font-variant-east-asian",
  "font-variant-ligatures",
  "font-variant-numeric",
  "font-weight",
  "height",
  "image-orientation",
  "image-resolution",
  "ime-mode",
  "isolation",
  "layout-flow",
  "layout-grid",
  "layout-grid-char",
  "layout-grid-char-spacing",
  "layout-grid-line",
  "layout-grid-mode",
  "layout-grid-type",
  "letter-spacing",
  "line-break",
  "line-height",
  "list-style",
  "list-style-position",
  "list-style-type",
  "margin",
  "margin-bottom",
  "margin-left",
  "margin-right",
  "margin-top",
  "marker-offset",
  "max-height",
  "max-width",
  "min-height",
  "min-width",
  "mix-blend-mode",
  "object-fit",
  "object-position",
  "opacity",
  "outline",
  "outline-color",
  "outline-style",
  "outline-width",
  "overflow",
  "overflow-x",
  "overflow-y",
  "padding",
  "padding-bottom",
  "padding-left",
  "padding-right",
  "padding-top",
  "page-break-after",
  "page-break-before",
  "page-break-inside",
  "pause",
  "pause-after",
  "pause-before",
  "pitch",
  "pitch-range",
  "quotes",
  "richness",
  "speak",
  "speak-header",
  "speak-numeral",
  "speak-punctuation",
  "speech-rate",
  "stress",
  "table-layout",
  "text-align",
  "text-align-last",
  "text-autospace",
  "text-combine-upright",
  "text-decoration",
  "text-decoration-color",
  "text-decoration-line",
  "text-decoration-skip",
  "text-decoration-style",
  "text-emphasis",
  "text-emphasis-color",
  "text-emphasis-style",
  "text-indent",
  "text-justify",
  "text-kashida-space",
  "text-orientation",
  "text-overflow",
  "text-transform",
  "text-underline-position",
  "text-wrap",
  "text-wrap-mode",
  "text-wrap-style",
  "unicode-bidi",
  "vertical-align",
  "voice-family",
  "white-space",
  "white-space-collapse",
  "width",
  "word-break",
  "word-spacing",
  "word-wrap",
  "writing-mode",
  "zoom"
];
function K(t, i) {
  return i ? t.split(",").map((r) => r.trim()).map((r) => {
    const s = r.replace(/\./g, "." + i + "_").replace(/#/g, "#" + i + "_");
    return s.toLowerCase().startsWith("body") ? "#" + i + " " + s.substring(4) : "#" + i + " " + s;
  }).join(",") : t;
}
function Q(t, i, r) {
  return t.trim().replace(/expression\((.*?)\)/g, "").replace(/url\(["']?(.*?)["']?\)/g, (s, l) => r ? `url("${encodeURI(r(decodeURI(l)))}")` : i.includes(l.toLowerCase().split(":")[0]) ? s : "");
}
function q(t, i, r, s, l) {
  if (!t)
    return;
  const n = [];
  for (let a = 0; a < t.length; a++) {
    const g = t[a];
    n.push(g);
  }
  for (const a of n)
    if (r.includes(a)) {
      const g = t.getPropertyValue(a);
      t.setProperty(a, Q(g, i, l), s ? t.getPropertyPriority(a) : void 0);
    } else
      t.removeProperty(a);
}
function O(t, i, r, s, l, n) {
  t.selectorText = K(t.selectorText, i), q(t.style, r, s, l, n);
}
const B = ["http", "https", "mailto"];
function X(t, { dropAllHtmlTags: i = !1, rewriteExternalLinks: r, rewriteExternalResources: s, id: l = "msg_" + String.fromCharCode(...new Array(24).fill(void 0).map(() => Math.random() * 25 % 25 + 65)), allowedSchemas: n = B, allowedCssProperties: a = J, preserveCssPriority: g = !0, noWrapper: m = !1 }) {
  var R, _, S, M;
  m && (l = "");
  const d = new DOMParser().parseFromString(t, "text/html");
  n = Array.isArray(n) ? n.map((e) => e.toLowerCase()) : B;
  const w = d.createNodeIterator(d.documentElement, NodeFilter.SHOW_COMMENT);
  let u;
  for (; u = w.nextNode(); )
    (R = u.parentNode) == null || R.removeChild(u);
  const x = [...G];
  i && x.push("style"), d.querySelectorAll(x.join(", ")).forEach((e) => e.remove());
  const b = [], A = d.createNodeIterator(d.body, NodeFilter.SHOW_ELEMENT);
  for (; u = A.nextNode(); ) {
    const e = u, c = e.tagName.toLowerCase();
    if (!(c === "body" || c === "html")) {
      if (i) {
        if (u.textContent) {
          const p = d.createTextNode(u.textContent);
          (_ = u.parentNode) == null || _.replaceChild(p, u);
        } else
          (S = u.parentNode) == null || S.removeChild(u);
        continue;
      }
      if (c in P) {
        const p = P[c];
        for (const o of e.getAttributeNames())
          if (!p.includes(o))
            e.removeAttribute(o);
          else if (o === "class" && !m)
            e.setAttribute(o, ((M = e.getAttribute(o)) == null ? void 0 : M.split(" ").map((f) => l + "_" + f).join(" ")) ?? "");
          else if (o === "id" && !m)
            e.setAttribute(o, l + "_" + (e.getAttribute(o) ?? ""));
          else if (o === "href" || o === "src") {
            const f = e.getAttribute(o) ?? "";
            o === "href" && r ? e.setAttribute(o, r(f)) : o === "src" && s ? e.setAttribute(o, s(f)) : n.includes(f.toLowerCase().split(":")[0]) || e.removeAttribute(o);
          }
        q(e.style, n, a, g, s), c === "a" && (e.setAttribute("rel", "noopener noreferrer"), e.setAttribute("target", "_blank"));
      } else
        b.push(e);
    }
  }
  for (let e = b.length - 1; e >= 0; e--) {
    const c = b[e], p = c.parentNode;
    if (p) {
      for (; c.firstChild; )
        p.insertBefore(c.firstChild, c);
      p.removeChild(c);
    }
  }
  const k = d.querySelectorAll("style");
  if (k.length) {
    const e = d.createElement("style");
    d.body.append(e);
    const c = e.sheet, p = [];
    k.forEach((o) => {
      const f = o, C = f.sheet;
      if (!C.cssRules) {
        f.textContent = "";
        return;
      }
      for (let N = 0; N < C.cssRules.length; N++) {
        const y = C.cssRules[N];
        if (y instanceof CSSStyleRule)
          O(y, l, n, a, g, s), p.push(y);
        else if (y instanceof CSSMediaRule) {
          const V = c.insertRule("@media {}", c.cssRules.length), E = c.cssRules[V], z = y;
          for (let L = 0; L < z.cssRules.length; L++) {
            const T = z.cssRules[L];
            T instanceof CSSStyleRule && (O(T, l, n, a, g, s), E.insertRule(T.cssText, E.cssRules.length));
          }
          p.push(z);
        }
      }
      f.remove();
    }), e.textContent = p.map((o) => o.cssText).join(`
`);
  }
  if (m)
    return d.body.innerHTML;
  {
    const e = d.createElement("div");
    return e.id = l, e.innerHTML = d.body.innerHTML, e.outerHTML;
  }
}
function Y(t) {
  const i = document.createElement("div");
  return i.textContent = t, i.innerHTML;
}
function Z(t, i, r) {
  let s = t ?? "";
  return (s == null ? void 0 : s.length) === 0 && i && (s = Y(i).split(`
`).map((l) => "<p>" + l + "</p>").join(`
`)), X(s, r ?? {});
}
const $ = ["innerHTML"], ee = ["title"], te = /* @__PURE__ */ F({
  __name: "Letter",
  props: {
    className: {},
    html: {},
    text: {},
    useIframe: { type: Boolean },
    iframeTitle: {},
    rewriteExternalLinks: {},
    rewriteExternalResources: {},
    allowedCssProperties: {},
    allowedSchemas: {},
    preserveCssPriority: { type: Boolean }
  },
  setup(t) {
    const i = t, {
      className: r,
      html: s,
      text: l,
      useIframe: n,
      iframeTitle: a,
      rewriteExternalLinks: g,
      rewriteExternalResources: m,
      allowedSchemas: d,
      allowedCssProperties: w,
      preserveCssPriority: u
    } = U(i), v = Z(s, l, {
      rewriteExternalResources: m,
      rewriteExternalLinks: g,
      allowedSchemas: d,
      preserveCssPriority: u,
      allowedCssProperties: w
    }), b = "data:text/html;charset=utf-8," + encodeURIComponent(v);
    return (A, k) => h(n) ? h(n) ? (H(), I("div", {
      key: 1,
      class: j([h(r)])
    }, [
      D("iframe", {
        src: b,
        title: h(a)
      }, null, 8, ee)
    ], 2)) : W("", !0) : (H(), I("div", {
      key: 0,
      class: j([h(r)]),
      innerHTML: h(v)
    }, null, 10, $));
  }
}), ie = {
  install: (t) => {
    t.component("Letter", te);
  }
};
export {
  te as Letter,
  ie as default
};
